import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../data.service';
import { Preinscripcio } from '../lib/model/preinscripcio';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-confirmacio',
  templateUrl: './confirmacio.component.html',
  styleUrls: ['./confirmacio.component.css']
})
export class ConfirmacioComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  preinscripcio: Preinscripcio;

  constructor(
      private dataService: DataService,
  ) {
    this.preinscripcio = dataService.preinscripcio;
  }

  ngOnInit() {
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/confirmacio/confirmacio.component.ts